import AnimatedHilbiLogo from './animated-hilbi-logo';

export default AnimatedHilbiLogo;
